import React, { Fragment } from 'react';
import classNames from "classnames/bind"
import { SRLWrapper } from "simple-react-lightbox"

import styles from './portfolio-skeleton-page.module.scss';
import { FluidImage } from "components/shared/fluid-image/FluidImage";
import { SectionDivider } from "components/shared/sectionDivider/SectionDivider";

const cx = classNames.bind(styles)

export const PortfolioSkeletonPage = ({portfolioData}) => {
    const {
        projectHeading,
        projectMainImage,
        additionalImages,
        aboutHeading,
        aboutPortfolioText,
        websiteGoalsHeading,
        websiteGoalsText,
        websiteGoalsListHeading,
        websiteGoalsList,
        myRoleHeading,
        position,
        company,
        timeWithCompany,
        myRoleText,
        jobSummaryIntro,
        jobSummaryList,
        technologiesUsedIntro,
        technologiesList
    } = portfolioData

    return (
        <div className={cx("portfolio-page")}>
            <div className={cx("container")}>
                <h1 className={cx(["animate__animated", "animate__fadeIn"])}>Portfolio: {projectHeading}</h1>

                <div className={cx("row")}>
                    <section className={cx("col-md-12")}>
                        <div className={cx(["portfolio-image-wrapper", "animate__animated", "animate__fadeIn"])}>
                            <FluidImage image={projectMainImage.image} altText={projectMainImage.alt} />

                            {additionalImages &&
                                <Fragment>
                                    <h2 className={cx("animate__animated", "animate__fadeIn")}>Additional Portfolio Images</h2>

                                    <div className={cx(['container', 'additional-images-wrapper', "animate__animated", "animate__fadeIn"])}>
                                        <SRLWrapper>
                                            {additionalImages.map( (additionalImage, index) => {
                                                return(
                                                    <a href={additionalImage.fullImage} data-attribute="SRL" className={cx('additional-image')} key={index} >
                                                        <img src={additionalImage.image} alt={additionalImage.alt} />
                                                    </a>
                                                )
                                            })}
                                        </SRLWrapper>
                                    </div>
                                </Fragment>
                            }
                        </div>


                        <div id={cx("about")}>
                            <h2 className={cx(["animate__animated", "animate__fadeIn"])}>{aboutHeading}</h2>
                            <div className={cx("row", "animate__animated", "animate__fadeIn")}>
                                {aboutPortfolioText.map( (text, index) => {
                                    return (
                                        <p key={index} className={cx(["col-12", "col-md-6"])} dangerouslySetInnerHTML={{__html: text}}></p>)
                                })}
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <div className={cx(["section-divider-wrapper", "animate__animated", "animate__fadeIn"])}>
                <SectionDivider />
            </div>

            <section>
                <div className={cx("container")}>
                    <div id={cx("websiteGoals")}>
                        <h2 className={cx("animate__animated", "animate__fadeIn")}>{websiteGoalsHeading}</h2>
                        <div className={cx(["row", "justify-content-between", "animate__animated", "animate__fadeIn"])}>
                            {websiteGoalsText.map( (text, index) => {
                                return (<p className={cx("col-12")} key={index} dangerouslySetInnerHTML={{__html: text}}></p>)
                            })}

                            <h3 className={cx(["col-12", "animate__animated", "animate__fadeIn"])}>{websiteGoalsListHeading}</h3>
                            <ul className={cx(["row", "justify-content-between", "animate__animated", "animate__fadeIn"])}>
                                {websiteGoalsList.map( (goal, index) => {
                                    return (
                                        <li className={cx(["col-12", "col-md-12"])} key={index} dangerouslySetInnerHTML={{__html: goal}}></li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <div className={cx(["section-divider-wrapper", "animate__animated", "animate__fadeIn"])}>
                <SectionDivider />
            </div>

            <section>
                <div className={cx("container")}>
                    <div id={cx("role")}>
                        <h2 className={cx("animate__animated", "animate__fadeIn")}>{myRoleHeading}</h2>

                        <div className={cx("row")}>
                            <div className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])}>
                                <h3>Position</h3>
                                <h4>{position}</h4>
                            </div>

                            <div className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])}>
                                <h3>Company</h3>
                                <h4>{company}</h4>
                            </div>

                            <div className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])}>
                                <h3>Time with Company</h3>
                                <h4>{timeWithCompany}</h4>
                            </div>
                        </div>
                        <div className={cx("row")}>
                            {myRoleText.map( (text, index) => {
                                return (
                                   <p className={cx(["col-12", "col-md-6", "animate__animated", "animate__fadeIn"])} key={index} dangerouslySetInnerHTML={{__html: text}}></p>
                                )
                            })}
                        </div>

                        <h2 className={cx(["animate__animated", "animate__fadeIn"])}>Job Responsibilities</h2>

                        <div className={cx("row")}>
                            <p className={cx(["col-12", "animate__animated", "animate__fadeIn"])}>{jobSummaryIntro}</p>
                            <ul className={cx(["responsibilities-list", "row"])}>
                                {jobSummaryList.map( (job, index) => {
                                    return (
                                        <li className={cx(["col-12", "col-md-6", "animate__animated", "animate__fadeIn"])} key={index} dangerouslySetInnerHTML={{__html: job}}></li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <div className={cx(["section-divider-wrapper"], "animate__animated", "animate__fadeIn")}>
                <SectionDivider />
            </div>

            <section>
                <div className={cx("container")}>

                    <div id={cx("technologies")}>
                        <h2 className={cx(["animate__animated", "animate__fadeIn"])}>Technologies Used</h2>
                        <p className={cx(["animate__animated", "animate__fadeIn"])}>{technologiesUsedIntro}</p>
                        <ul className={cx("row")}>
                            {technologiesList.map( (tech, index) => {
                                return (
                                    <li className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])} key={index} dangerouslySetInnerHTML={{__html: tech}}></li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </section>

            {/*<div id="additional-projects">*/}
            {/*<h2>Additional Projects</h2>*/}
            {/*<p>lorem</p>*/}
            {/*</div>*/}
            {/*</section>*/}
            {/*</div>*/}
            {/*</div>*/}
        </div>
    )
}